module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAJCAYAAAACTR1pAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACbSURBVHgBlZHNDcMgDIUxE3SU3vlR2aQZISNkg27QjNANWglxzwgdIXcQ9PmAlEZCIU8yQg8+Y2MSUAjhmnO+iE4ZYz4E6F5KeYpzGiWWBbH2EnhkjTG+pFJqISLXAzOUUnLQl6rpvb8hwfsAdNwf72U12cAHDS0ISYcK/YEsa+3cgEe0NG8Nub/BMEqaNuVNWuuH6BWPiaN1/gOmlEauFCMx8AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/icon-arrow-gray.png
// module id = mrLF
// module chunks = 0